import CalendarRollUpViewState from '../../store/schema/CalendarRollUpViewState';
import ConversationReadingPaneViewState from '../../store/schema/ConversationReadingPaneViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import mailStore from 'owa-mail-store/lib/store/Store';
import readingPaneStore from '../../store/Store';
import isNewestOnBottom from '../../utils/isNewestOnBottom';

export const MEETING_RESPONSE_ITEM_CLASS_REGEX = /ipm.schedule.meeting.resp/i;
export const ACCEPTED_ITEM_CLASS = /^ipm\.schedule\.meeting\.resp\.pos/i;
export const TENTATIVE_ITEM_CLASS = /^ipm\.schedule\.meeting\.resp\.tent/i;
export const DECLINED_ITEM_CLASS = /^ipm\.schedule\.meeting\.resp\.neg/i;
export const CANCELED_ITEM_CLASS = /^ipm\.schedule\.meeting\.canceled/i;
export const MEETING_REQUEST_ITEM_CLASS = /^ipm\.schedule\.meeting\.request/i;

export function isCalendarRollUpEnabled(): boolean {
    // Disable the calendar roll up flight if the meeting card flight is on as it provides
    // alternate UI for attendee response tracking and item part states
    return isFeatureEnabled('rp-calendarRollup') && !isFeatureEnabled('cal-mf-mailCalendarCard');
}

export function createCalendarRollUpViewState(itemClass: string): CalendarRollUpViewState {
    return {
        isCalendarResponse: MEETING_RESPONSE_ITEM_CLASS_REGEX.test(itemClass),
        isCalendarRequest: MEETING_REQUEST_ITEM_CLASS.test(itemClass),
        calendarReponseNodeIds: [],
        acceptedAttendees: [],
        tentativeAttendees: [],
        declinedAttendees: [],
        proposedNewTimeAttendeesCount: 0,
        isExpanded: false,
        isLoading: true,
    };
}

export function hasCalendarRollUpInConversation(
    conversationViewState: ConversationReadingPaneViewState
): boolean {
    if (!isCalendarRollUpEnabled()) {
        return false;
    }

    let hasCalendarRollUp = false;
    if (conversationViewState?.itemPartsMap) {
        conversationViewState.itemPartsMap.forEach(itemPart => {
            if (itemPart.calendarRollUpViewState.calendarReponseNodeIds.length) {
                hasCalendarRollUp = true;
            }
        });
    }
    return hasCalendarRollUp;
}

export function getLatestMeetingRequestNodeId(): string {
    const { conversationReadingPaneViewState } = readingPaneStore;
    if (!conversationReadingPaneViewState) {
        return null;
    }

    const conversation = mailStore.conversations.get(
        conversationReadingPaneViewState.conversationId.Id
    );
    if (!conversation || !conversation.conversationNodeIds.length) {
        return null;
    }

    const { conversationNodeIds } = conversation;
    const isNewestOnBottomSetting = isNewestOnBottom();
    let index = isNewestOnBottomSetting ? conversationNodeIds.length - 1 : 0;
    const indexIncrement = isNewestOnBottomSetting ? -1 : 1;

    while (index >= 0 && index <= conversationNodeIds.length - 1) {
        const nodeId = conversationNodeIds[index];
        const itemPartViewState = conversationReadingPaneViewState.itemPartsMap.get(nodeId);
        if (itemPartViewState && itemPartViewState.calendarRollUpViewState.isCalendarRequest) {
            return nodeId;
        }

        index += indexIncrement;
    }

    return null;
}
